import { render } from "./DataGridPagination.vue?vue&type=template&id=4b4d94c6&ts=true"
import script from "./DataGridPagination.vue?vue&type=script&lang=ts"
export * from "./DataGridPagination.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__